// extracted by mini-css-extract-plugin
export default {"body":"WKXPNAfPDtjd5fqvV0gs","image":"jx2jvTkCNUf9lQf826ie","text":"CZJQj7clfd7o66_LAb0u"};